<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            
            <br />

            <div style="margin: 0px 20px;">
              <div v-if="list === true">
                <div class="float-left">
                  <strong style="color: #000A2C; text-align: left; margin: 20px;" class="class-teach-name">Teaching Experience</strong>
                </div>
                <div class="float-right">
                  <strong class="custom-text-viewall" style="margin: 20px;" @click="AddNewExperience()">Add Experience</strong>
                </div>
                <div style="clear: both"></div>
                <br />
                <div v-for="exp in experience" v-bind:key="exp.Id">
                  <CCard  style="margin-bottom: 10px;">
                    <div class="mt-2 mb-2">                   
                      <CRow style="margin-right: 0px; margin-left: 0px;">
                        <div style="width: 70%" class="float-left">
                          <label class="text-primary-custom ml-2 mb-0 text-left" style="color: #000A2C; font-size:12px;">{{exp.school}}</label>                  
                          <!-- <label class="custom-user-subtitle ml-2" style="color: #000A2C;">{{exp.year}}</label> -->
                        </div>
                        <div style="width: 30%" class="float-right">
                          <CRow class="ml-3 mr-3 mt-2">
                            <CCol style="width: 50%; flex-basis: auto;" class="float-right">
                              <img src="../../assets/img/icon/pencil-edit.svg" style="-webkit-filter:invert(62%) sepia(12%) saturate(0%) hue-rotate(262deg) brightness(100%) contrast(88%); filter: invert(62%) sepia(12%) saturate(0%) hue-rotate(262deg) brightness(100%) contrast(88%); width:20px; height:20px" @click="EditExp(exp.id)" />
                            </CCol>
                            <CCol style="width: 50%" class="float-right">
                              <img src="../../assets/img/icon/trash.svg" style="-webkit-filter:invert(32%) sepia(75%) saturate(4835%) hue-rotate(8deg) brightness(98%) contrast(101%); filter: invert(32%) sepia(75%) saturate(4835%) hue-rotate(8deg) brightness(98%) contrast(101%);" @click="DeleteExpPopup(exp.id)" />
                            </CCol>
                          </CRow>
                        </div>
                      </CRow>
                    </div>
                  </CCard>
                </div>
              </div>
            </div>

            <div v-if="addnew === true">
              <h4 style="color: #000; text-align: left" class="custom-user-name">
                Teaching School
              </h4>
              <div class="ml-3 mr-3">
                <v-select
                  horizontal
                  v-model="schoolSelected"
                  :options="listSchool"
                  label="schoolName"
                  placeholder="Select School"
                />
              </div>

              <br />

              <h4 style="color: #000; text-align: left" class="custom-user-name">
                Teaching Subject
              </h4>
              <div class="ml-3 mr-3">
                <v-select
                  horizontal
                  v-model="subjectSelected"
                  :options="listSubject"
                  label="subjectName"
                  placeholder="Select Subject"
                />
              </div>

              <br />

              <h4 style="color: #000; text-align: left" class="custom-user-name">
                Teaching Grade
              </h4>
              <div class="ml-3 mr-3">
                <v-select
                  horizontal
                  v-model="gradeSelected"
                  :options="listGrade"
                  label="gradeName"
                  placeholder="Select Grade"
                />
              </div>

              <br />

              <h4 style="color: #000; text-align: left" class="custom-user-name">
                Teaching Period
              </h4>
              <CRow class="ml-1 mr-2">
                <div style="width: 40%" class="float-left">
                  <h4 style="color: #000; text-align: left" class="custom-user-name">
                    Year Start
                  </h4>
                </div>
                <div style="width: 20%" class="float-right">
                  <input type="number" v-model="yearStart" />
                </div>
                <div style="clear: both"></div>
              </CRow>
              <br />
              <CRow class="ml-1 mr-2">
                <div style="width: 40%" class="float-left">
                  <h4 style="color: #000; text-align: left" class="custom-user-name">
                    Year End
                  </h4>
                </div>
                <div style="width: 20%" class="float-right">
                  <input type="number" v-model="yearend" />
                </div>
                <div style="clear: both"></div>
              </CRow>

              <br />

              <CRow class="ml-4 mr-2 d-sm-down-none">
                <div style="width: 30%" class="float-left">
                  <label class="" style="color: #000A2C; font-weight: 400;">
                    Is this your current job ?
                  </label>
                </div>
                <div style="width: 20%" class="float-right">
                  <input type="checkbox" v-model="currentJob" value="true" />
                </div>
                <div style="clear: both"></div>
              </CRow>

              <CRow class="ml-4 mr-2 d-sm-flex d-md-none">
                <div style="width: 45%" class="float-left">
                  <label class="" style="color: #000A2C; font-weight: 400;">
                    Is this your current job ?
                  </label>
                </div>
                <div style="width: 20%" class="float-right">
                  <input type="checkbox" v-model="currentJob" value="true" />
                </div>
                <div style="clear: both"></div>
              </CRow>

              
              

              <div v-if="EditExperience === true">
                <div class="bottom-center">
                  <CButton class="btn-select-blue mt-5" @click="SubmitEdit(schoolSelected, subjectSelected, gradeSelected, expId)">Edit Experience</CButton>
                </div>
              </div>

              <div v-else>
                <div class="bottom-center">
                  <CButton class="btn-select-blue mt-5" @click="SubmitAddNew(schoolSelected, subjectSelected, gradeSelected)">Add Experience</CButton>
                </div>
              </div>

            </div>

            

            
          </div>
        </div>
      </div>
    </CContainer>

    <CModal size="md" :show.sync="ConfirmDelete">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">
          Confirm Delete
        </h3>
        <br />
      </div>
      <div class="text-center">
        <h4 class="sub-title-header" style="color: #000a2c">
          Are you sure to delete selected experience ?
        </h4>
        <br />
      </div>
      <!-- <div class="text-center">
        <CButton class="btn-select-blue mt-5">No, I Change My Mind</CButton>
      </div> -->
      <div class="text-center">
        <CButton class="btn-select-blue mt-2" @click="DeleteExperience(expId)">
          Yes, I'm sure
        </CButton>
      </div>
    </CModal>

    
    <div class="header-top">Teaching School</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);

export default {
  data() {
    return {
      user: {},
      teacher: {},
      experience: [],
      listSchool: [],
      listSubject: [],
      listGrade: [],

      schoolSelected: "",
      subjectSelected: "",
      gradeSelected: "",
      schoolSelectedId: "",
      subjectSelectedId: "",
      gradeSelectedId: "",
      yearStart: "",
      yearend: "",
      expId : "",
      currentJob: false,

      list: true,
      addnew: false,
      ConfirmDelete: false,
      EditExperience: false,
      
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetTeacherProfile(this.user.id);
            this.GetTeacherExperiences(this.user.id);
            this.GetSchoolList();
            this.GetSubjectList();
            this.GetGradeList();
          }
        });
    },

    GetTeacherProfile() {
      return this.$API
        .get(this.$TeacherProfile + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.teacher = response.data;
          }
        });
    },

    GetTeacherExperiences() {
      return this.$API
        .get(this.$TeacherExperiences + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.experience = response.data;
          }
        });
    },

    GetSchoolList() {
      return this.$API
        .get(this.$SchoolList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.listSchool = response.data;
          }
        });
    },

    GetSubjectList() {
    this.$API
      .get(this.$SubjectListAuthorize, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.listSubject = response.data;
          console.log("subject",this.listSubject);
        }
      });
    },

    GetGradeList() {
      this.$API
        .get(this.$GradeListAuthorize, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.listGrade = response.data;
          }
        });
    },

    AddNewExperience() {
      this.list = false;
      this.addnew = true;
    },

    SubmitAddNew(schoolSelected, subjectSelected, gradeSelected) {
      // this.list = true;
      for (let s = 0; s < this.listSchool.length; s++) {
        var sch = this.listSchool[s];
        // console.log("testacad", ac);

        if (sch.schoolName == schoolSelected.schoolName)
        {
          var schId = sch.id;
          this.schoolSelectedId = schId;
          console.log("testschId", this.schoolSelectedId);

          for (let i = 0; i < this.listSubject.length; i++) {
            var sub = this.listSubject[i];

            if (sub.subjectName == subjectSelected.subjectName)
            {
              var subId = sub.id;
              this.subjectSelectedId = subId;
              console.log("testsubId", this.subjectSelectedId);
              
              for (let g = 0; g < this.listGrade.length; g++) {
                var gra = this.listGrade[g];
                
                if (gra.gradeName == gradeSelected.gradeName)
                {
                  var graId = gra.id;
                  this.gradeSelectedId = graId;
                  console.log("testgraId", this.gradeSelectedId);

                  // if (this.otherEducation == "")
                  // {
                  //   this.otherEducation = 
                  // }

                  const formData = new FormData();

                  formData.append("teacherid", this.teacher.teacherId);
                  formData.append("GradeId", this.gradeSelectedId);
                  formData.append("SubjectId", this.subjectSelectedId);
                  formData.append("SchoolId", this.schoolSelectedId);
                  formData.append("StartYear", this.yearStart);
                  formData.append("EndYear", this.yearend);
                  formData.append("IsCurrentJob", this.currentJob);
                  formData.append("Status", true);

                  return this.$API
                    .post(this.$UpdateTeachingExperience, formData, {
                      withCredentials: true,
                    })
                    .then((response) => {
                      if (response.status == 200) {
                        this.Busy = false;
                        this.$dialog.alert("Success add").then(function () {});
                        this.GetTeacherExperiences(this.user.id);
                        this.list = true;
                        this.addnew = false;
                      } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function () {});
                      }
                    })
                    .catch((error) => {
                      this.Busy = false;
                      this.Loading = false;
                      this.Error = true;
                      this.Message = error.response.data.message;
                    });

                }
              }

            }
          }
        }
      }      
    },

    EditExp(id) {
      this.expId = id;
      console.log("testexpid", this.expId);
      this.list = false;
      this.addnew = true;
      this.EditExperience = true;
    },

    SubmitEdit(schoolSelected, subjectSelected, gradeSelected, expId) {
      // this.list = true;
      for (let s = 0; s < this.listSchool.length; s++) {
        var sch = this.listSchool[s];
        // console.log("testacad", ac);

        if (sch.schoolName == schoolSelected.schoolName)
        {
          var schId = sch.id;
          this.schoolSelectedId = schId;
          console.log("testschId", schoolSelectedId);

          for (let i = 0; i < this.listSubject.length; i++) {
            var sub = this.listSubject[i];

            if (sub.subjectName == subjectSelected.subjectName)
            {
              var subId = sub.id;
              this.subjectSelectedId = subId;
              console.log("testsubId", this.subjectSelectedId);
              
              for (let g = 0; g < this.listGrade.length; g++) {
                var gra = this.listGrade[g];
                
                if (gra.gradeName == gradeSelected.gradeName)
                {
                  var graId = gra.id;
                  this.gradeSelectedId = graId;
                  console.log("testgraId", this.gradeSelectedId);

                  // if (this.otherEducation == "")
                  // {
                  //   this.otherEducation = 
                  // }

                  const formData = new FormData();

                  formData.append("id", expId);
                  formData.append("teacherid", this.teacher.teacherId);
                  formData.append("GradeId", this.gradeSelectedId);
                  formData.append("SubjectId", this.subjectSelectedId);
                  formData.append("SchoolId", this.schoolSelectedId);
                  formData.append("StartYear", this.yearStart);
                  formData.append("EndYear", this.yearend);
                  formData.append("IsCurrentJob", this.currentJob);
                  formData.append("Status", true);

                  return this.$API
                    .post(this.$UpdateTeachingExperience, formData, {
                      withCredentials: true,
                    })
                    .then((response) => {
                      if (response.status == 200) {
                        this.Busy = false;
                        this.$dialog.alert("Success add").then(function () {});
                        this.GetTeacherExperiences(this.user.id);
                        this.list = true;
                        this.addnew = false;
                      } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function () {});
                      }
                    })
                    .catch((error) => {
                      this.Busy = false;
                      this.Loading = false;
                      this.Error = true;
                      this.Message = error.response.data.message;
                    });

                }
              }

            }
          }
        }
      }      
    },


    DeleteExpPopup(id) {
      this.expId = id;
      this.ConfirmDelete = true;
    },

    DeleteExperience: function(expId) {
      const formData = new FormData();

      formData.append("id", expId);

      return this.$API
        .post(this.$DeleteTeacherExperience, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success deleted").then(function () {});
            this.GetTeacherExperiences(this.user.id);
            this.ConfirmDelete = false;
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to add").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },


    GoBack() {
      this.$router.back();
    },
    // GoToTutorDetailAbout() {
    //   this.$router.push("/Tutor/TutorDetailAbout");
    // },
    // GetSubject() {
    //   this.$API
    //     .get(this.$SubjectListAuthorize, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.subject = response.data;
    //         this.FilterSubject = this.subject;
    //       }
    //     });
    // },
    // ApplyFilter: function () {
    //   var arr = _.orderBy(this.edus, ["eduName"], ["asc"]);
    //   if (_.isEmpty(arr) == false) {
    //     const result = _.filter(arr, ({ eduName }) =>
    //       _.some([
    //         _.includes(!eduName || eduName.toLowerCase(), [
    //           this.SearchQuery.toLowerCase(),
    //         ]),
    //       ])
    //     );
    //     this.FilterEducation = result;
    //   }
    // },
    GoToEdit()
    {
       this.$router.push("EditTutorTeachingSchool");
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="checkbox"] {
  opacity: inherit;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height */

  /* #000A2C */

  color: #000a2c;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

</style>